import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import HttpService from "../../helpers/httpServices";
import { useDispatch } from "react-redux";
import { toast } from "sonner";
import axios from "axios";

const Country = () => {
  const [activeTab, setActiveTab] = useState("Country");
  const [selectedCounties, setSelectedCounties] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [countries, setCountries] = useState([]);
  const [loader, setLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = ["Country"];

  // Toggle country active/inactive
  const handleToggleCountry = async (country) => {
    const newStatus = !selectedCounties.includes(country.code);

    setLoader(true);
    try {
      const res = await axios.put(HttpService.update_country_status, {
        id: country._id,
        isActive: newStatus,
      });

      if (res.status === 200) {
        toast.success(res.data.message);

        // Update selectedCounties in state
        setSelectedCounties((prev) =>
          newStatus
            ? [...prev, country.code]
            : prev.filter((c) => c !== country.code)
        );
      }
    } catch (err) {
      console.error("Error updating country status:", err);
      toast.error("Failed to update country status");
    } finally {
      setLoader(false);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      const res = await axios.get(HttpService.school_country_show);
      if (res.status === 200) {
        const fetchedCountries = res.data.data || [];

        setCountries(fetchedCountries);

        // Set selected countries
        const selected = fetchedCountries
          .filter((c) => c.isActive)
          .map((c) => c.code);
        setSelectedCounties(selected);
      }
    } catch (err) {
      console.error("Error fetching countries:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleTabClick = (tab) => setActiveTab(tab);

  useEffect(() => {
    fetchData();
  }, [refresh]);

  useEffect(() => {
    if (location.state?.currentTab) {
      setActiveTab(location.state.currentTab);
    }
  }, [location.state?.currentTab]);

  return (
    <>
      <Title name="Country" />
      <Topbar title="Country Management" />
      <div className="p-6 space-y-6 pr-0">
        {/* Tabs */}
        <div className="flex justify-between flex-wrap gap-y-2">
          <div className="flex gap-2 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`px-3 py-2 rounded-lg whitespace-nowrap ${
                  activeTab === tab
                    ? "bg-secondary_main text-white"
                    : "bg-white text-black"
                }`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Country Content */}
        {activeTab === "Country" && (
          <div className="rounded-lg p-6 relative text-gray-800 max-w-md">
            <h2 className="text-2xl font-semibold mb-4">Countries</h2>

            {/* Selected tags */}
            <div className="flex gap-2 mb-4 flex-wrap">
              {selectedCounties.length > 0 ? (
                selectedCounties.map((val) => {
                  const label = countries.find((c) => c.code === val)?.name;
                  return (
                    <div
                      key={val}
                      className="border border-purple-400 text-primary_main px-4 py-1 rounded-full text-sm"
                    >
                      {label}
                    </div>
                  );
                })
              ) : (
                <div className="text-gray-400 text-sm">No countries selected</div>
              )}
            </div>

            {/* Dropdown */}
            <div className="relative">
              <div
                className={`border-blue-400 p-3 flex bg-white justify-between rounded cursor-pointer select-none border-b-0 ${
                  showDropdown ? "border-b-0" : ""
                }`}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <div className="text-gray-600">Select Countries</div>
                <svg
                  className={`w-5 h-5 transform transition-transform duration-300 ${
                    showDropdown ? "rotate-180" : "rotate-0"
                  }`}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </div>

              {showDropdown && (
                <div className="absolute bg-white border-blue-400 w-full rounded p-2 z-10 max-h-64 overflow-y-auto">
                  {countries.map((country) => (
                    <label
                      key={country.code}
                      className="flex items-center space-x-2 py-1 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={selectedCounties.includes(country.code)}
                        onChange={() => handleToggleCountry(country)}
                        className="accent-primary_main"
                      />
                      <span>{country.name}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>

            {loader && <div className="mt-4 text-sm text-gray-500">Updating...</div>}
          </div>
        )}
      </div>
    </>
  );
};

export default Country;
